import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { DocumentModel } from 'src/app/models/document.model';
import { Subscription } from 'rxjs';
import { RequestStatusService } from '../../../../requeststatus.service';
import { ActorStatusInformationModel } from 'src/app/models/api/actor-status-information.model';
import { BadgeStatusEnum } from 'src/app/constants/badge-status.enum';

@Component({
    selector: 'desktop-request-status-actions-by-person',
    templateUrl: './desktop-request-status-actions-by-person.component.html',
    styleUrl: './request-status-actions-by-person.component.scss' 
})
export class DesktopRequestStatusActionsByPersonComponent implements OnInit, OnDestroy {

    private _actorsOfSendgroup: ActorStatusInformationModel[] = [];
    @Input() set actorsOfSendgroup(val: ActorStatusInformationModel[]){
        this._actorsOfSendgroup = val;
        if(this._actorsOfSendgroup){
            this.actionsByPerson = this._actorsOfSendgroup;
        }
    }

    @Input() sortingAllowed: boolean = false;
    @Input() lastItemOfPersonsInSendgroup: boolean = false;
    
    actionsByPerson: any;
    documents: DocumentModel[] = [];

    private actorsSubscription!: Subscription;

    constructor(protected requestStatusService: RequestStatusService) {
        this.actorsSubscription = this.requestStatusService.actors$.subscribe(() => {
            if (this._actorsOfSendgroup) {
                this.actionsByPerson = this._actorsOfSendgroup;
            }
        })
    }

    ngOnInit(): void {
        if (this._actorsOfSendgroup) {
            this.actionsByPerson = this._actorsOfSendgroup;
        }
    }

    ngOnDestroy(): void {
        if (this.actorsSubscription) {
            this.actorsSubscription.unsubscribe();
        }
    }
}

@Component({
    selector: 'mobile-request-status-actions-by-person',
    templateUrl: './mobile-request-status-actions-by-person.component.html',
    styleUrl: './request-status-actions-by-person.component.scss'
})
export class MobileRequestStatusActionsByPersonComponent implements OnInit, OnDestroy {

    private _actorsOfSendgroup: ActorStatusInformationModel[] = [];
    @Input() set actorsOfSendgroup(val: ActorStatusInformationModel[]){
        this._actorsOfSendgroup = val;
        if(this._actorsOfSendgroup){
            this.actionsByPerson = this._actorsOfSendgroup;
        }
    }

    @Input() sortingAllowed: boolean = false;
    @Input() sendgroupStatus!: BadgeStatusEnum;
    
    actionsByPerson: any;
    documents: DocumentModel[] = [];

    private actorsSubscription!: Subscription;

    constructor(protected requestStatusService: RequestStatusService) {
        this.actorsSubscription = this.requestStatusService.actors$.subscribe(() => {
            if (this._actorsOfSendgroup) {
                this.actionsByPerson = this._actorsOfSendgroup;
            }
        })
    }

    ngOnInit(): void {
        if (this._actorsOfSendgroup) {
            this.actionsByPerson = this._actorsOfSendgroup;
        }
    }

    ngOnDestroy(): void {
        if (this.actorsSubscription) {
            this.actorsSubscription.unsubscribe();
        }
    }
}